// ----------------------------------------------------------------------------
// Component: Content Slider
// ----------------------------------------------------------------------------
//
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import Swiper, { Scrollbar, A11y, Keyboard, Navigation, Pagination, Mousewheel } from 'swiper';

// Style includes
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_content-slider.scss';


// -------------------------------------
// Variables
// -------------------------------------
const CAROUSEL_SELECTOR = '.carousel--content-slider';
const CAROUSEL_CLASS = 'carousel--content-slider';
const CAROUSEL_SECTION_SELECTOR = '.content-slider.isSlider--true';
const CAROUSEL_SECTION_CLASS = 'content-slider';
const CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
const CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';
const CAROUSEL_CURRENT_COUNTER_SELECTOR = '.swiper-counter__current-number';


// -------------------------------------
// Hooks
// -------------------------------------
document.querySelectorAll(CAROUSEL_SECTION_SELECTOR)
    .forEach((element, index) => {


        // Generate unique class for each collection list slider
        element.querySelector(CAROUSEL_SELECTOR).classList.add(`${CAROUSEL_CLASS}-${index}`);

        // Generate unique btn classes for slider arrows
        element.querySelector(CAROUSEL_PREV_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-prev-${index}`);
        element.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-next-${index}`);

        const currentCounter = element.querySelector(CAROUSEL_CURRENT_COUNTER_SELECTOR);

        const swiper = new Swiper(`.${CAROUSEL_CLASS}-${index}`, {
            // Optional parameters
            modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard, Mousewheel],
            slidesPerView: 1.06,
            spaceBetween: 15,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
            grabCursor: true,
            mousewheel: {
                forceToAxis: true
            },

            breakpoints: {
                // when window width is >= 1280px
                1280: {
                    slidesPerView: 'auto',
                    spaceBetween: 15
                }
            },

            // Navigation arrows
            navigation: {
                nextEl: `.${CAROUSEL_SECTION_CLASS}-btn-next-${index}`,
                prevEl: `.${CAROUSEL_SECTION_CLASS}-btn-prev-${index}`
            },
            on: {
                init: function(swiper) {
                    currentCounter.textContent = swiper.realIndex + 1;
                },
                slideChange: function (swiper) {
                    currentCounter.textContent = swiper.realIndex + 1;
                },
            }
        });

        swiper.slides.forEach(function(slide, index) {
            const slideLink = slide.querySelector('a');

            if (slideLink) {
                slideLink.addEventListener('focus', function() {
                    swiper.slideTo(index);
                });
            }
        });
    });

